export default {
  GET_DASHBOARD_DATA_SUCCESS: "GET_DASHBOARD_DATA_SUCCESS",
  DASHBOARD_LOADING: "DASHBOARD_LOADING",
  GET_BEST_SELLING_PRODUCTS_SUCCESS: "GET_BEST_SELLING_PRODUCTS_SUCCESS",
  GET_SALES_REPORT_SUCCESS: "GET_SALES_REPORT_SUCCESS",
  GET_SOLD_QUANTITIES_REPORT_SUCCESS: "GET_SOLD_QUANTITIES_REPORT_SUCCESS",
  GET_VAT_REPORT_SUCCESS: "GET_VAT_REPORT_SUCCESS",
};
